export default "__VITE_ASSET__flCwPHBo__"